"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictationSettingsManager = void 0;
// This is only accessible through DictationSettingsManager
var MainDictationSettings = /** @class */ (function () {
    function MainDictationSettings(dictationSettings) {
        this.mergeDictationSettings(dictationSettings);
    }
    MainDictationSettings.prototype.mergeDictationSettings = function (dictationSettings) {
        var _this = this;
        Object.keys(dictationSettings).forEach(function (key) {
            _this[key] = dictationSettings[key];
        });
    };
    return MainDictationSettings;
}());
var DictationSettingsManager = /** @class */ (function () {
    function DictationSettingsManager() {
    }
    Object.defineProperty(DictationSettingsManager, "dictationSettings", {
        get: function () {
            if (DictationSettingsManager._instance) {
                return DictationSettingsManager._instance;
            }
            else {
                throw new Error('Dictation Settings not initialized');
            }
        },
        // Example: DictationSettingsManager.dictationSettings = { useCorrections: "false" };
        set: function (dictationSettings) {
            if (DictationSettingsManager._instance) {
                DictationSettingsManager._instance.mergeDictationSettings(dictationSettings);
            }
            else {
                DictationSettingsManager._instance = new MainDictationSettings(dictationSettings);
            }
        },
        enumerable: false,
        configurable: true
    });
    return DictationSettingsManager;
}());
exports.DictationSettingsManager = DictationSettingsManager;
//# sourceMappingURL=dictationSettings.js.map